var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"menu"},[_c('ul',{staticClass:"menu-list"},_vm._l((_vm.menuList),function(child,index){return _c('base-menu-item',{key:index,attrs:{"menuItem":child}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }